<template>
  <div class="video-search">
    <!-- 0省教育厅 1市教育局 2区县教育局 3乡镇中心校/街道教育办 -->
    <div class="city-search" style="padding-top: 20px">
      <!-- <div class="city-title">
        <div class="span-pitch" ref="cityRef" @click="cityTitleClick()">
          选择城市
          <img
            class="active-img"
            src="@/assets/img/eduBigData/big-data-selected-city.png"
            alt=""
          />
        </div>
        <div class="span-no-pitch" ref="areaRef">
          选择区域
          <img
            class="active-img"
            src="@/assets/img/eduBigData/big-data-selected-city.png"
            alt=""
          />
        </div>
      </div> -->
    </div>
    <div class="city-or-area-list">
      <el-button
        type="text"
        class="city-item"
        @click="goBack()"
        v-show="isShowBack"
      >
        返回上级
      </el-button>
      <el-button
        type="text"
        v-for="(item, index) in cityList"
        :key="index"
        class="city-item"
        :class="{ active: isSelected == index }"
        @click="cityClick(item, index)"
        :title="item.regionName"
      >
        {{ item.regionName }}
      </el-button>
    </div>
    <div class="school-title-left" :title="'监控接入学校总数(' + schoolTotal + '所)'">监控接入学校总数({{ schoolTotal }}所)</div>
    <el-input
      placeholder="请输入内容"
      size="mini"
      v-model="searchParams.schoolName"
      class="input-with-select search-school"
    >
      <el-button
        class="school-search-btn"
        slot="append"
        size="mini"
        @click="schoolSearch()"
        icon="el-icon-search"
      ></el-button>
    </el-input>
    <el-collapse
      class="collapse-box school-collapse-box"
      v-infinite-scroll="load"
      infinite-scroll-distance="5"
      accordion
    >
      <el-collapse-item v-for="(item, index) in schoolList" :key="index">
        <template slot="title">
          <div class="collapse-title" @click="selectSchool(item, index)">
            <div class="title-school-info">
              <div class="title-school-name"
                   @mouseover="handleMouseOver(item)"
                   @mouseleave="handleMouseleave(item)">
                {{ item.schoolName }}
              </div>
              <div class="title-school-name_title" v-show="item.showBox"> {{item.schoolName}}</div>
              <div class="title-school-icon-address">
                <img src="@/assets/img/schoolMonitorCenter/school-location.png" alt="" />
                <div class="title-school-address">{{ item.schoolAddress }}</div>
              </div>
            </div>
            <div class="title-school-monitor">
              <img src="@/assets/img/schoolMonitorCenter/select-video-seat-icon.png" alt="" />
              <div class="monitor-info">
                <div>{{ item.monitorNum }}</div>
                <div>监控总数</div>
              </div>
            </div>
          </div>
        </template>
        <div class="collapse-content">
          <div
            class="monitor-adddress"
            v-for="(monitor, key) in item.monitorsInfo"
            :key="key"
            @click="selectMonitor(monitor, key)"
          >
            {{ monitor.monitorName }}
          </div>
        </div>
      </el-collapse-item>
      <div
        class="no-school"
        v-if="( pages == searchParams.pageNum - 1 && pages != 0 ) || searchParams.pageNum == pages"
      >
        --到底了，没有更多学校了--
      </div>
    </el-collapse>
  </div>
</template>

<script>
export default {
  name: "schoolSearchVideo",
  components: {},
  props: {
    totalData: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      isShowBack: false,
      showBox: false,
      selectEduBuresuType: "",
      backObject0: {}, // 省
      backObject1: {}, // 市
      backObject2: {}, // 区
      backObject3: {}, // 乡镇
      cityList: [],
      isSelected: 0,
      schoolTotal: 0,
      searchParams: {
        eduId: "", //教育局id
        regionCode: "", //教育局编码
        eduBuresuType: "", //教育局类型
        schoolName: "", //输入框搜索学校名称
        pageNum: 1 //页码
      },
      isLoadAdd: false,
      schoolList: [],
      pageSize: "",
      pages: 0 // 总页数
    };
  },
  created() {
    // this.$nextTick(() => {
    //   this.cityTitleClick();
    // });
  },
  mounted() {},
  computed: {
    eduSchoolInfo() {
      return this.$store.state.eduSchoolInfo;
    },
    eduSelectVideo() {
      return this.$store.state.eduSelectVideo;
    }
  },
  watch: {
    totalData: function(newVal) {
      this.cityList = this.getCityList(newVal.regions);
      this.getLoginEdu();

      this.isLoadAdd = false;
      this.schoolList = [];
      this.searchParams.eduId = newVal.regions.eduId;
      this.searchParams.regionCode = newVal.regions.regionCode;
      this.searchParams.eduBuresuType = newVal.regions.eduBuresuType;
      this.searchParams.schoolName = "";
      this.searchParams.pageNum = 1;
      // console.log(this.searchParams)
      this.getSchoolList(this.searchParams);
    }
  },
  methods: {
    handleMouseOver(item){
      item.showBox = true;
      this.$forceUpdate()
    },
    handleMouseleave(item){
      item.showBox = false;
      this.$forceUpdate()
    },
    cityTitleClick() {
      // 省教育厅
      this.$refs.cityRef.className = "span-pitch"; //城市是选中的
      this.$refs.areaRef.className = "span-no-pitch"; //区域是未选中的
      this.cityList = this.getCityList(this.totalData.regions);
      let eduInfo = JSON.parse(sessionStorage.getItem("eduInfo"));
      // console.log(eduInfo)
      let upLevel = {
        eduBuresuType: eduInfo.eduBuresuType,
        eduId: eduInfo.eduId,
        regionCode: eduInfo.regionCode,
        regionName: eduInfo.regionName
      };
      // console.log(upLevel)
      this.$store.commit("updateEduSelectInfo", upLevel);
      this.cityClick(upLevel, 0);
    },
    getCityList(val) {
      this.isSelected = 0;
      let data = Array.from(val.region || []);
      let obj = {
        eduBuresuType: val.eduBuresuType,
        eduId: val.eduId,
        regionCode: val.regionCode,
        regionName: val.regionName
      };
      // delete obj.region
      data.unshift(obj);
      // console.log(val);
      // console.log(data);
      return data;
    },
    cityClick(item, index) {
      // console.log(item)
      // console.log(index);
      this.modifyBackShow(item.eduBuresuType);
      this.selectEduBuresuType = item.eduBuresuType;
      // console.log(this.selectEduBuresuType)
      if (this.selectEduBuresuType == 0) {
        this.backObject0 = item;
      } else if (this.selectEduBuresuType == 1) {
        this.backObject1 = item;
      } else if (this.selectEduBuresuType == 2) {
        this.backObject2 = item;
      } else if (this.selectEduBuresuType == 3) {
        this.backObject3 = item;
      }
      // this.isSelected = index;
      // console.log(this.selectEduBuresuType)
      this.$store.commit("updateEduSelectInfo", item);

      // this.isLoadAdd = false;
      // this.schoolList = [];
      // // console.log(item)
      // this.searchParams.eduId = item.eduId;
      // this.searchParams.regionCode = item.regionCode;
      // this.searchParams.eduBuresuType = item.eduBuresuType;
      // this.searchParams.schoolName = "";
      // this.searchParams.pageNum = 1;
      // this.getSchoolList(this.searchParams);

      if (item.region) {
        this.cityList = this.getCityList(item);
        // 省教育厅
        this.$refs.areaRef.className = "span-pitch"; //城市是选中的
        this.$refs.cityRef.className = "span-no-pitch"; //区域是未选中的
      }

      // console.log(this.selectEduBuresuType)
    },
    // 判断登录是哪一级教育局登录
    getLoginEdu() {
      let eduInfo = JSON.parse(sessionStorage.getItem("eduInfo"));
      let backObject = {
        eduBuresuType: eduInfo.eduBuresuType,
        eduId: eduInfo.eduId,
        regionCode: eduInfo.regionCode,
        regionName: eduInfo.regionName
      };
      if (eduInfo.eduBuresuType == 0) {
        this.backObject0 = backObject;
      } else if (eduInfo.eduBuresuType == 1) {
        this.backObject1 = backObject;
      } else if (eduInfo.eduBuresuType == 2) {
        this.backObject2 = backObject;
      } else if (eduInfo.eduBuresuType) {
        this.backObject3 = backObject;
      }
    },
    // 判断返回按钮是否显示
    modifyBackShow(eduBuresuType) {
      let eduInfo = JSON.parse(sessionStorage.getItem("eduInfo"));
      if (eduBuresuType == eduInfo.eduBuresuType) {
        this.isShowBack = false;
      } else {
        this.isShowBack = true;
      }
    },
    // 返回上级
    goBack() {
      let eduInfo = JSON.parse(sessionStorage.getItem("eduInfo"));
      // console.log(this.selectEduBuresuType)
      // console.log(eduInfo.eduBuresuType)
      this.modifyBackShow(this.selectEduBuresuType);
      if (this.selectEduBuresuType == 3) {
        if (eduInfo.eduBuresuType < 3) {
          this.selectEduBuresuType = 2;
          this.$store.commit("updateEduSelectInfo", this.backObject2);
          if (eduInfo.eduBuresuType == 2) {
            this.isShowBack = false;
          }
        } else {
          this.isShowBack = false;
        }
      } else if (this.selectEduBuresuType == 2) {
        if (eduInfo.eduBuresuType < 2) {
          this.selectEduBuresuType = 1;
          this.$store.commit("updateEduSelectInfo", this.backObject1);
          if (eduInfo.eduBuresuType == 1) {
            this.isShowBack = false;
          }
        } else {
          this.isShowBack = false;
        }
      } else if (this.selectEduBuresuType == 1) {
        if (eduInfo.eduBuresuType < 1) {
          this.selectEduBuresuType = 0;
          this.$store.commit("updateEduSelectInfo", this.backObject0);
          if (eduInfo.eduBuresuType == 0) {
            this.isShowBack = false;
          }
        } else {
          this.isShowBack = false;
        }
      } else {
        let upLevel = {
          eduBuresuType: eduInfo.eduBuresuType,
          eduId: eduInfo.eduId,
          regionCode: eduInfo.regionCode,
          regionName: eduInfo.regionName
        };
        this.selectEduBuresuType = 0;
        this.isShowBack = false;
        this.$store.commit("updateEduSelectInfo", upLevel);
      }

      // this.isLoadAdd = false;
      // this.schoolList = [];
      // this.searchParams.eduId = this.$store.state.eduSelectInfo.eduId;
      // this.searchParams.regionCode = this.$store.state.eduSelectInfo.regionCode;
      // this.searchParams.eduBuresuType = this.$store.state.eduSelectInfo.eduBuresuType;
      // this.searchParams.schoolName = "";
      // this.searchParams.pageNum = 1;
      // this.getSchoolList(this.searchParams);
    },

    // 学校输入查询
    schoolSearch() {
      this.searchParams.pageNum = 1;
      this.schoolList = [];
      this.getSchoolList(this.searchParams);
    },
    // 滚动加载
    load() {
      // console.log(this.searchParams.pageNum)
      if (
        this.searchParams.eduId == "" ||
        this.searchParams.pageNum >= this.pages
      ) {
        return;
      }
      this.searchParams.pageNum++;
      this.getSchoolList(this.searchParams);
    },
    async getSchoolList(params) {
      let req = {
        eduId: parseInt(params.eduId),
        regionCode: parseInt(params.regionCode),
        eduBuresuType: parseInt(params.eduBuresuType),
        schoolName: params.schoolName,
        pageNum: params.pageNum
      };
      let res = await this.$Http.getSchoolList(req);
      if (res.code == 200) {
        // 判断是否是滚动加载的视频
        let isLoadAdd = this.isLoadAdd;
        if (!isLoadAdd) {
          this.isLoadAdd = true;
          this.$store.commit("updateEduSchoolInfo", res.data);
        }

        this.schoolTotal = res.data.total;
        this.pages = res.data.pages;
        // console.log(this.pages)
        // 滚动加载数组
        let oldArray = this.schoolList;
        res.data.list.forEach(item => {
          item.showBox=false
        })
        let newArray = res.data.list;
        let totalArray = [];

        this.schoolList = oldArray.concat(newArray);
      } else if (res.code == 101) {
        this.schoolTotal = 0;
        this.schoolList = [];
      } else {
        this.$message({
          type: "error",
          message: res.messsage
        });
      }
    },
    selectMonitor(item) {
      // console.log(item)
      this.$store.commit("updateEduSelectVideo", item);
    },
    selectSchool(item) {
      // console.log(item);
      this.$store.commit("updateEduSelectSchool", item);
    }
  },
  destroyed() {}
};
</script>

<style lang="scss" scoped>
.city-search {
  display: flex;
  flex-direction: row;
  .city-title {
    margin-top: 15px;
    margin-left: 20px;
    width: 180px;
    height: 33px;
    line-height: 33px;
    font-size: 14px;
    background: url("~@/assets/img/schoolBaseInfo/key-file-bg.png") center center no-repeat;
    background-size: 100% 100%;
    display: flex;
    flex-direction: row;
    div {
      &:first-child {
        cursor: pointer;
      }
    }
    .span-pitch {
      width: 50%;
      text-align: center;
      color: rgba(196, 240, 255, 1);
      position: relative;
      img {
        display: block;
        position: absolute;

        left: 8px;
        top: 4px;
      }
    }
    .span-no-pitch {
      width: 50%;
      text-align: center;
      color: rgba(196, 240, 255, 0.6);
      img {
        display: none;
      }
    }
  }
}
.city-or-area-list {
  width: 96%;
  margin: 0px 2%;
  height: 128px;
  overflow: scroll;
  scrollbar-width: none;
  .city-item {
    color: #c4f0ff;
    font-size: 16px;
    width: 23%;
    margin: 0px 1%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    &.active {
      color: #ffff00;
    }
  }
}
.school-title-left {
  margin-top: 15px;
  align-items: center;
  height: 30px;
  min-width: 166px;
  max-width: 338px;
  text-align: center;
  color: #c4f0ff;
  line-height: 30px;
  font-size: 18px;
  background-image: linear-gradient(
    to left,
    rgba(143, 149, 255, 0),
    rgba(63, 120, 188, 1),
    rgba(143, 149, 255, 0)
  );
  border-radius: 4px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  position: relative;
  left: 16px;
}
.input-with-select {
  margin: 5px 5% 0px 5%;
  width: 90%;
}
.el-input {
  width: 301px;
  height: 32px;
  // box-shadow: 0px 0px 28px 0px #3f78bc inset;
  border-radius: 1px;
}
.el-button {
  &.school-search-btn {
    width: 45px;
    height: 30px;
    background: #3f78bc;
    box-shadow: 0px 0px 28px 0px #3f78bc inset;
    border-radius: 1px;
    position: relative;
    left: -1px;
    font-size: 12px;
  }
}
.el-button + .el-button {
  margin-left: 0px;
}
.collapse-box {
  margin: 5px 5%;
  width: 90%;
  overflow: scroll;
  scrollbar-width: none;
  height: 500px;
  background-color: transparent;
  border: none;
}
.collapse-title {
  height: 80px;
  width: 100%;
  background-color: transparent;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .title-school-info {
    position: relative;
    height: 80px;
    padding-left: 20px;
    width: 60%;
    display: flex;
    justify-content: center;
    // align-items: center;
    flex-direction: column;
    line-height: 1;
    .title-school-name {
      width: 100%;
      font-size: 16px;
      color: #c4f0ff;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
    .title-school-name_title{
      position: absolute;
      bottom:10px;
      background-color: #fff;
      padding: 5px 5px;
      font-size: 14px;
      font-weight: 550;
      border-radius: 2px;
    }
    .title-school-icon-address {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      padding-top: 5px;
      img {
        width: 12px;
        height: 12px;
        margin-right: 10px;
      }
      .title-school-address {
        width: 140px;
        // height: 12px;
        color: rgba(255, 255, 255, 0.5);
        font-size: 12px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
    }
  }
  .title-school-monitor {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    line-height: 1;
    img {
      width: 40px;
      height: 40px;
    }
    .monitor-info {
      margin-right: 10px;
      div {
        &:first-child {
          font-size: 16px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #c4f0ff;
          line-height: 22px;
        }
        &:last-child {
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(196, 240, 255, 0.8);
          line-height: 20px;
        }
      }
    }
  }
}
.collapse-content {
  background-color: transparent;
  display: flex;
  flex-wrap: wrap;
  .monitor-adddress {
    margin-bottom: 8px;
    margin-right: 8px;
    width: 108px;
    height: 31px;
    padding: 0 5px;
    box-shadow: 0px 0px 16px 0px #3f78bc inset;
    border-radius: 1px;
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #c4f0ff;
    line-height: 31px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    cursor: pointer;
    &:nth-child(3n) {
      margin-right: 0;
    }
  }
}
.no-school {
  text-align: center;
  color: rgba(255, 255, 255, 0.5);
}
.pagination-box {
  height: 20px;
  float: right;
  margin-right: 5%;
}
.video-search {
  /deep/ .input-with-select {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    background: transparent;
    /* box-shadow: 0px 0px 28px 0px #3f78bc inset; */
    border-radius: 1px;
    .el-input__inner {
      width: 302px;
      height: 32px;
      color: #fff;
      background: transparent;
      box-shadow: 0px 0px 28px 0px #3f78bc inset;
      border-radius: 1px;
      border-color: #1e2675;
    }
    .el-input-group__append {
      background-color: transparent;
      color: #909399;
      vertical-align: middle;
      display: table-cell;
      position: relative;
      border: 1px solid #dcdfe6;
      border: none;
      border-radius: 4px;
      padding: 0 20px;
      width: 1px;
      white-space: nowrap;
    }
  }
  /deep/ .school-collapse-box {
    .el-collapse-item__wrap {
      background-color: transparent;
    }
    .el-collapse-item__header {
      height: 60px;
      background-color: transparent;
    }
    .el-icon-arrow-right:before {
      color: #c4f0ff;
    }
    .el-collapse-item__content {
      padding-bottom: 0;
    }
    .el-collapse-item {
      &.is-disabled {
        .el-collapse-item__header {
          cursor: pointer;
        }
      }
    }
  }
}
</style>
